import * as React from "react";
import { Redirect } from "react-router";
import constants from "src/helpers/constants";

const Home = () => {
  return <Redirect to={`/topic/${constants.DEFAULT_TOPIC_ID()}`} />;
};

export default Home;
